import { type UseMutationOptions, useMutation } from "@tanstack/react-query";
import { useParams } from "react-router";
import { useApi } from "~hooks/apiHooks/useApi";
import type { FixtureUpsert } from "~pages/Fixtures/types";
import type { FixtureResponse } from "~types/fixture.ts";

export const useUpdateFixture = (options: UseMutationOptions<FixtureResponse, unknown, FixtureUpsert> = {}) => {
  const request = useApi();
  const { sport, organizationId, fixtureId } = useParams();

  return useMutation<FixtureResponse, unknown, FixtureUpsert, unknown>({
    mutationFn: (body: FixtureUpsert) => {
      if (!sport || !organizationId || !fixtureId) {
        throw new Error("Missing required params");
      }

      return request(
        `${sport}/o/${organizationId}/fixtures/${fixtureId}?include=seasons,entities,persons,venues,seasonStages,seasonPools,seasonSeries,seasonRounds`,
        {
          method: "PUT",
          body,
        },
      );
    },
    ...options,
  });
};
